import React from 'react';
import AreaLandingPage, { AreaConfig } from '../components/AreaLandingPage';

const vileParle: AreaConfig = {
  name: 'Vile Parle',
  slug: 'vile-parle',
  tagline: 'Doorstep Mobile Repair in Vile Parle, Mumbai',
  description:
    'Get your phone repaired at home in Vile Parle without stepping out. minto sends a certified technician to Vile Parle East or West — screen crack, battery drain, charging port issues all fixed in under an hour.',
  localities: [
    'Vile Parle East', 'Vile Parle West', 'Santacruz East', 'Santacruz West',
    'Vakola', 'Airport Zone', 'JVPD Scheme', 'Juhu', 'Parle Point',
    'Nehru Road', 'S.V. Road', 'Irla', 'Navpada',
  ],
  zones: [
    {
      name: 'Vile Parle West — JVPD & Juhu',
      line: 'Western Line',
      station: 'Vile Parle West Station',
      localities: ['JVPD Scheme', 'Vile Parle West', 'Irla', 'Juhu Scheme', 'Nehru Road', 'S.V. Road'],
      desc: 'The quieter, residential side of Vile Parle. Our technicians cover JVPD Scheme, Juhu-adjacent streets, and Irla colony.',
    },
    {
      name: 'Vile Parle East — Airport Zone',
      line: 'Western Line',
      station: 'Vile Parle East Station',
      localities: ['Vile Parle East', 'Navpada', 'Parle Point', 'Airport Road', 'WEH Service Road', 'Nehru Nagar'],
      desc: 'Vile Parle East and the airport-facing zones covered. Ideal for travellers needing quick repairs before or after flights.',
    },
    {
      name: 'Santacruz & Vakola',
      line: 'Western Line',
      station: 'Santacruz Station',
      localities: ['Santacruz West', 'Santacruz East', 'Vakola', 'Milan Subway', 'Kalina', 'Kalanagar adjacent'],
      desc: 'Santacruz East, West, and Vakola form the southern border of our Vile Parle zone. Full doorstep coverage across all pincode areas.',
    },
  ],
  seo: {
    title: 'Mobile Repair in Vile Parle | Doorstep Phone Repair | minto',
    description:
      'Doorstep mobile repair in Vile Parle East & West, Santacruz, Vakola & Juhu, Mumbai. Screen replacement, battery repair. Certified technicians, 90-day warranty. Book now!',
    keywords:
      'mobile repair Vile Parle, phone repair Vile Parle, screen repair Vile Parle, battery replacement Vile Parle, iPhone repair Vile Parle, Samsung repair Vile Parle, mobile repair Santacruz, Juhu phone repair, Vakola mobile repair, JVPD phone repair, doorstep repair Vile Parle',
  },
  faqs: [
    {
      q: 'Do you offer doorstep repair in Vile Parle East?',
      a: 'Yes, we cover all of Vile Parle East including Navpada, Parle Point, and the Airport zone. Technician arrives within 60–90 minutes.',
    },
    {
      q: 'Do you also cover Juhu and Santacruz near Vile Parle?',
      a: 'Yes! Santacruz East, Santacruz West, Vakola, and Juhu-adjacent areas are covered under our Vile Parle service zone.',
    },
    {
      q: 'How much does iPhone battery replacement cost in Vile Parle?',
      a: 'iPhone battery replacement starts from ₹1,499 depending on the model. Select your iPhone on the booking page for the exact price.',
    },
    {
      q: 'Can you repair my phone before my flight at the airport zone?',
      a: 'Yes, we offer priority bookings in the airport zone. Book at least 2 hours before your departure for guaranteed service.',
    },
    {
      q: 'Is there a warranty on repairs done in Vile Parle?',
      a: 'Yes, all repairs come with a 90-day warranty covering the same issue if it recurs.',
    },
  ],
};

const VileParlePage: React.FC = () => <AreaLandingPage area={vileParle} />;
export default VileParlePage;
